// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"754022b4","75":"66969e76","453":"6af2d48e","615":"3fa078c0","740":"55f63261","746":"638cc212","815":"c82eedcb","818":"bfd4acf1"}[chunkId] + ".chunk.js";
};